import { elementInView, throttle } from './utils';

const setupLoadMorePosts = () => {
  const loadMore = document.getElementById('loadMorePosts');
  if (!loadMore) return;
  const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const handleScrollCount = () => {
    if (elementInView(loadMore, 0)) {
      console.log('loading posts');
    }
  };

  window.addEventListener('scroll', () => {
    if (mediaQuery && !mediaQuery.matches) {
      throttle(handleScrollCount(), 250);
    }
  });
};

export default setupLoadMorePosts;
